import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Input } from 'components/fields'
import { Anchor, Note, Title } from 'components/misc'
import { ElevatedButton } from 'components/layout'
import { form } from 'helpers/decorators'

@injectIntl
@form({
  form: 'sendAssessorRequest',
  disableHook: true
})
class AssessorApproval extends Component {
  static propTypes = {
    noSupervisor: PropTypes.bool,
    loading: PropTypes.bool,
    hasSupervisor: PropTypes.bool,
    onOpenAlreadyAssessed: PropTypes.func,
    handleSubmit: PropTypes.func,
    onSubmit: PropTypes.func,
    reset: PropTypes.func,
    intl: PropTypes.object,
    colorClass: PropTypes.string,
    isAssessorManagementEnabled: PropTypes.bool,
    isAssessorSetup: PropTypes.bool
  }

  handleSubmit = fields =>
    this.props.onSubmit(fields, { resetForm: this.props.reset })

  handleOpenAlreadyAssessed = () => this.props.onOpenAlreadyAssessed()

  render() {
    const {
      loading,
      colorClass,
      noSupervisor,
      handleSubmit,
      hasSupervisor,
      isAssessorManagementEnabled,
      isAssessorSetup,
      intl
    } = this.props
      const supervisingRole = hasSupervisor && !isAssessorManagementEnabled
        ? intl.formatMessage({
          id: 'roles.supervisor',
          defaultMessage: 'Supervisor'
        })
        : intl.formatMessage({ id: 'roles.assessor', defaultMessage: 'Assessor' })

    const showApprovalControl = (isAssessorSetup && isAssessorManagementEnabled) || (!noSupervisor && !isAssessorManagementEnabled)

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Title
          colorClass={colorClass}
          h2
          style={{ textAlign: 'center', paddingTop: '10px' }}
        >
          <FormattedMessage
            id="moduleTitle.assessor_approval"
            defaultMessage="Assessor Approval"
            values={{
              role: supervisingRole
            }}
          />
        </Title>

        <Note margin="20px 0 30px">
          {(noSupervisor && !isAssessorManagementEnabled)
            ? <FormattedMessage
                id="label.to_send_assessment_request"
                defaultMessage="If you would like to send assessment request electronically, please fill {role}'s email"
                values={{
                  role: supervisingRole
                }}
            />
            : <FormattedMessage
                id="label.before_submitting_your_aj"
                defaultMessage="Before sending your Journey to Award Leader, you first need approval from your {role}. If you want, you can add personal note also."
                values={{
                  role: supervisingRole
                }}
            />}
        </Note>

        {showApprovalControl &&
          <Input
            name="note"
            label="Note for assessor"
            intlKey={
              hasSupervisor && !isAssessorManagementEnabled
                ? 'label.note_for_supervisor'
                : 'label.note_for_assessor'
            }
            optional
          />}

        {showApprovalControl &&
          <ElevatedButton
            colorClass={colorClass}
            uppercase
            rounded
            submit
            padded
            fullWidth
            isLoading={loading}
            intlKey="button.send_for_approval"
          >
            Send for approval
          </ElevatedButton>}

        <Anchor
          block
          center
          underline
          margin="15px 0 0"
          colorClass={colorClass}
        >
          {!isAssessorManagementEnabled && <a onClick={this.handleOpenAlreadyAssessed}>
            <FormattedMessage
              id="button.i_already_have_assessment"
              defaultMessage="I already have an assessment"
            />
          </a>}
        </Anchor>
      </form>
    )
  }
}

export default AssessorApproval
